import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {TeamModel} from "../models/team.model";

export class TeamsRequestsService {

  constructor(private teamsAPI: BringozApi, private $teams) {
  }

  // ******************************
  //        Public methods
  // ******************************

  createTeam(team: TeamModel) {
    const api = this.teamsAPI.actions.createTeam;
    return this.$$call(api, {}, team, {});
  }

  editTeam(team: TeamModel) {
    const api = this.teamsAPI.actions.editTeam;
    return this.$$call(api, {}, team, {teamId: team.id});
  }

  deleteTeam(teamId: string) {
    const api = this.teamsAPI.actions.deleteTeam;
    return this.$$call(api, {}, {}, {teamId: teamId});
  }

  updateTeamAdmins(team: TeamModel) {
    const api = this.teamsAPI.actions.updateTeamAdmins;
    return this.$$call(api, {}, team, {teamId: team.id});
  }

  getTeamsAgentIds(teamIds: string[]) {
    const api = this.teamsAPI.actions.getTeamsAgentIds;
    return this.$$call(api, {teamIds: teamIds}, {}, {});
  }

  getTeamMembersByUser(userId: string) {
    const api = this.teamsAPI.actions.getTeamMembersByUser;
    return this.$$call(api, {}, {memberId: userId}, {});
  }

  // ******************************
  //        Private methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$teams().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.teams')
  .service('teamsRequestsService', TeamsRequestsService);
